import { render, staticRenderFns } from "./PromoNotificationBox.vue?vue&type=template&id=664577c2&scoped=true&"
import script from "./PromoNotificationBox.vue?vue&type=script&lang=js&"
export * from "./PromoNotificationBox.vue?vue&type=script&lang=js&"
import style0 from "./PromoNotificationBox.vue?vue&type=style&index=0&id=664577c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664577c2",
  null
  
)

export default component.exports